/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'filter' })
@Injectable()
export class FilterPipe implements PipeTransform {
  transform(items, searchTerm: any, field?: string) {
    const filteredList = [];
    if (searchTerm) {
      const newSearchTerm = !isNaN(searchTerm)
        ? searchTerm.toString()
        : searchTerm.toString().toUpperCase();
      let prop;

      if (field) {
        return items.filter(item => {
          prop = isNaN(item[field])
            ? item[field].toString().toUpperCase()
            : item[field].toString();
          if (prop.indexOf(newSearchTerm) > -1) {
            filteredList.push(item);
            return filteredList;
          }
        });
      }

      return items.filter(item => {
        for (const key in item) {
          prop = isNaN(item[key])
            ? item[key].toString().toUpperCase()
            : item[key].toString();
          if (prop.indexOf(newSearchTerm) > -1) {
            filteredList.push(item);
            return filteredList;
          }
        }
      });
    }

    return items;
  }
}
